import React, { useEffect } from "react";

import {
    TRANSLATION_LANGUAGES,
    LANGUAGE_NAMES,
    HUMAN_FRIENDLY_LANGUAGE_NAME,
} from "~constants/i18n";
import { Language } from "~types/types";
import { capitalize } from "~utils/stringUtil";
import { Tracker } from "~utils/tracker";

import styles from "./style.module.css";

interface TranslationDisclaimerProps {
    position: "top" | "bottom";
    sourceLanguage: Language;
    targetLanguage: TRANSLATION_LANGUAGES;
}

const translationTracker = new Tracker({
    event: "translation_event",
    category: "engagement",
});

const TranslationNotice: React.FC<
    Omit<TranslationDisclaimerProps, "position">
> = ({ sourceLanguage, targetLanguage }) => {
    useEffect(() => {
        translationTracker.trackEvent({
            action: "impression",
            label: `article_in_${targetLanguage}`,
        });
    }, []);

    return (
        <div className={styles.translationDisclaimer}>
            This article has been translated from{" "}
            {capitalize(LANGUAGE_NAMES[sourceLanguage])} to{" "}
            {HUMAN_FRIENDLY_LANGUAGE_NAME[targetLanguage]}.
        </div>
    );
};

const TranslationDisclaimer: React.FC<TranslationDisclaimerProps> = ({
    position,
    sourceLanguage,
    targetLanguage,
}) => {
    if (position === "top") {
        return (
            <TranslationNotice
                sourceLanguage={sourceLanguage}
                targetLanguage={targetLanguage}
            />
        );
    }

    return (
        <div className={styles.translationDisclaimer}>
            This service may contain translation powered by Google. Google
            disclaims all warranties related to the translations, express or
            implied, including any warranties of accuracy, reliability, and any
            implied warranties of merchantability, fitness for a particular
            purpose and noninfringement.
        </div>
    );
};

export default TranslationDisclaimer;
